import React from 'react';

// App-wide error boundary — catches render-time crashes in any page and shows
// a recovery screen instead of a blank white page.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Surface to the console for debugging; in production this is where a
    // Sentry/LogRocket hook would go.
    console.error('UI crash caught by ErrorBoundary:', error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ minHeight: '100vh', background: '#f0f2f8', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Arial, sans-serif', padding: 24 }}>
        <div style={{ background: 'white', borderRadius: 12, padding: 40, maxWidth: 520, textAlign: 'center', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
          <div style={{ fontSize: 48, marginBottom: 8 }}>⚠️</div>
          <h2 style={{ margin: '0 0 8px', color: '#1a1a2e', fontSize: 20 }}>Something went wrong</h2>
          <p style={{ margin: '0 0 20px', color: '#888', fontSize: 14, lineHeight: 1.5 }}>
            An unexpected error occurred while rendering this page. You can try reloading, or head back to the dashboard.
          </p>
          {this.state.error?.message && (
            <pre style={{ background: '#FCEBEB', color: '#A32D2D', padding: '10px 14px', borderRadius: 6, fontSize: 12, textAlign: 'left', overflow: 'auto', marginBottom: 20 }}>
              {String(this.state.error.message)}
            </pre>
          )}
          <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
            <button onClick={() => window.location.reload()} style={{ padding: '9px 20px', background: '#3B3A8F', color: 'white', border: 'none', borderRadius: 6, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Reload Page</button>
            <button onClick={() => { window.location.href = '/dashboard'; }} style={{ padding: '9px 20px', background: '#f0f2f8', color: '#333', border: '1px solid #ddd', borderRadius: 6, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Go to Dashboard</button>
          </div>
        </div>
      </div>
    );
  }
}
